import React, { useEffect, useState } from 'react';
import { focusCountdown } from './focusCountdown.js';
export default function FocusTimerTrigger({ controller, expanded, onOpen }) {
  const [state, setState] = useState(() => controller?.getState());
  useEffect(() => {
    if (!controller) { setState(null); return; }
    return controller.subscribe(setState);
  }, [controller]);
  const phase = state?.session?.status;
  useEffect(() => {
    if (!controller || !['running', 'break'].includes(phase)) return;
    // One small toolbar component ticks locally; no parent or server polling.
    const tick = () => setState(controller.getState());
    const timer = setInterval(tick, 1000);
    document.addEventListener('visibilitychange', tick);
    return () => { clearInterval(timer); document.removeEventListener('visibilitychange', tick); };
  }, [controller, phase]);
  const countdown = focusCountdown(state);
  const description = countdown ? `${countdown.label} · ${countdown.time}` : 'Focus Timer';
  return <button type="button" className={`btl-reader-music-trigger btl-reader-focus-trigger${countdown ? ' has-countdown' : ''}`}
    aria-label="Open focus timer" aria-description={description} title={description} aria-haspopup="dialog" aria-expanded={expanded} onClick={onOpen}>
    <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="13" r="8"/><path d="M12 8v5l3 2M9 2h6M12 2v3"/></svg>
    {countdown && <span className="btl-focus-mini" aria-label={description}>{countdown.label !== 'Focus' && <small>{countdown.label}</small>}<span>{countdown.time}</span></span>}
  </button>;
}
